module.exports = __webpack_public_path__ + "static/media/energetic_happy.ee3b9064.svg";